import clsx from 'clsx';
import React from 'react';

import ArticleAsset from '@components/FeedItems/ArticleAsset';
import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import PictureCaption, { PICTURE_CAPTION_CLASSES } from '../PictureCaption';
import { type ThemeViewsProps, getGatedContent } from '../interfaces';
import Content from './Content';
import Video from './Video';

const Standard = ({
  article,
  env,
  midArticleUnitType,
  mostPopularArticles,
  newsletterId,
  relatedArticles,
  relatedEvent,
}: ThemeViewsProps) => {
  const {
    advertisement,
    authors,
    freeBlurb,
    highlight,
    id,
    isPro,
    media,
    pickups,
    picture,
    pictureCaption,
    pictureLink,
    publishedAt,
    scriptList,
    subTitle,
    title,
  } = article;

  const { fullText, takeaway, addendum } = getGatedContent(article);

  return (
    <div className="px-16 sm:px-28">
      <div className="relative m-auto max-w-container-lg">
        <div className="mb-24 flex flex-col items-center justify-between sm:mb-48 lg:mb-72">
          <div className="z-10 mb-32 w-full flex-1 sm:mb-48 lg:mb-32">
            <Header highlight={highlight} title={title} subTitle={subTitle} />
          </div>
          {!media ? (
            <figure className="relative m-0 aspect-[16/9] w-full" aria-labelledby="caption-text">
              {isPro && (
                <IconProTagArticle className="absolute right-0 top-0 w-[65px] sm:w-[119px]" />
              )}
              {pictureLink ? (
                <a href={pictureLink}>
                  <ArticleAsset
                    title={title}
                    id={id}
                    picture={picture}
                    env={env}
                    wrapperClassName="aspect-[16/9] w-full"
                  />
                </a>
              ) : (
                <ArticleAsset
                  title={title}
                  id={id}
                  picture={picture}
                  env={env}
                  wrapperClassName="aspect-[16/9] w-full"
                />
              )}
              <PictureCaption className="block !w-full" pictureCaption={pictureCaption} />
            </figure>
          ) : (
            <Video access={article.access} media={media} />
          )}
        </div>
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && article.access !== 'locked',
          })}
        >
          <div className="flex flex-col-reverse md:flex-row md:gap-72 xl:gap-112">
            <div className="flex-1">
              <div className="mb-40 sm:mb-48 md:mb-64">
                <ArticleDetails authors={authors} publishedAt={publishedAt} articleId={id} />
              </div>
            </div>
            <div
              className={clsx(
                PICTURE_CAPTION_CLASSES,
                'hidden md:block md:w-[195px] md:flex-shrink-0 lg:w-[260px]'
              )}
            />
          </div>
          <Content
            access={article.access}
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            midArticleUnitType={midArticleUnitType}
            mostPopularArticles={mostPopularArticles}
            newsletterId={newsletterId}
            picture={picture}
            pickups={pickups}
            relatedArticles={relatedArticles}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            takeaway={takeaway}
          />
        </div>
      </div>
    </div>
  );
};

export default Standard;
